import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { questionTypes } from "../../constants/QuestionType";
import { viewSingleForm } from "../../redux/actions/forms";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_USER_FORM } from "../../GraphQl/Queries";
import {
  CREATE_ANON_RESPONSE,
  CREATE_FORM_RESPONSE,
} from "../../GraphQl/Mutations";
import { FaSpinner } from "react-icons/fa";
import { DecodeURL, darkenColor, getContrastColor } from "../../functions";
import ThankyouPage from "./ThankyouPage";
import Loader from "../../components/Loader";
import { message } from "antd";
const Paragraph = (props) => {
  const [res, setRes] = useState(null);
  const handleRes = (e) => {
    setRes(e.target.value);
  };

  useEffect(() => {
    props?.updateResponse(res);
  }, [res]);

  return (
    <div>
      <div className='viewerFormQuestionWrapper'>
        <div className='viewerQuestionTitle'>
          <span>{props.question?.questionTitle}</span>
          <span className='requiredStatus'>
            {props?.question?.required ? "*Required" : ""}
          </span>
        </div>
        <input
          type='text'
          placeholder={props?.placeholder || "Enter your answer"}
          className='viewerQuestionInput'
          onKeyUp={(e) => handleRes(e)}
          required={props?.question?.required}
        />
      </div>
    </div>
  );
};
const LinearScale = (props) => {
  const [res, setRes] = useState(null);
  const handleRes = (e) => {
    setRes(JSON.stringify(e));
  };

  useEffect(() => {
    props?.updateResponse(res);
  }, [res]);
  return (
    <div>
      <div className='viewerFormQuestionWrapper'>
        <div className='viewerQuestionTitle'>
          <span>{props?.question?.questionTitle}</span>
          <span className='requiredStatus'>
            {props?.question?.required ? "*Required" : ""}
          </span>
        </div>
        <div className='viewerQuestionBody flex items-center'>
          {Array(5)
            .fill(0)
            .map((input, idx) => (
              <>
                <div className='LinearScaleWrapper' key={idx}>
                  <input
                    type='radio'
                    name={props?.question?.questionTitle}
                    id={props?.question?.questionTitle + (idx + 1)}
                    className='linearScaleInput'
                    onChange={(e) => handleRes(idx + 1)}
                    required={props?.question?.required}
                  />
                  <label
                    htmlFor={props?.question?.questionTitle + (idx + 1)}
                    className='linearScaleLabel'
                  >
                    {idx + 1}
                  </label>
                </div>
              </>
            ))}
        </div>
      </div>
    </div>
  );
};
const CheckBox = (props) => {
  const [res, setRes] = useState(null);
  const [options, setOptions] = useState([]);
  const handleRes = (e) => {
    const option = e.target.value;
    let updatedOptions = [...options];

    if (e.target.checked) {
      updatedOptions.push(option);
    } else {
      updatedOptions = updatedOptions.filter((o) => o !== option);
    }

    setOptions(updatedOptions);
    setRes(JSON.stringify(updatedOptions));
  };

  useEffect(() => {
    props?.updateResponse(res);
  }, [res]);

  return (
    <div>
      <div className='viewerFormQuestionWrapper'>
        <div className='viewerQuestionTitle'>
          <span>{props?.question?.questionTitle}</span>
          <span className='requiredStatus'>
            {props?.question?.required ? "*Required" : ""}
          </span>
        </div>
        {props?.question?.questionMetadata?.choices?.map((option, idx) => (
          <div className='choiceInputWrapper'>
            <input
              type='checkbox'
              className='ui-checkbox'
              name={props?.questionTitle + " " + props?.question?.id}
              value={option}
              id={option + props?.question?.id}
              required={props?.question?.required}
              onChange={(e) => handleRes(e)}

              // onChangeCapture={(e) => handleRes(e)}
            />{" "}
            <label
              htmlFor={option + props?.question?.id}
              style={{
                fontFamily: props?.font,
              }}
            >
              {option}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
const Radio = (props) => {
  const [res, setRes] = useState(null);
  const handleRes = (e) => {
    // console.log(e.target.value);
    setRes(e.target.value);
  };

  useEffect(() => {
    props?.updateResponse(res);
  }, [res]);
  return (
    <div>
      <div className='viewerFormQuestionWrapper'>
        <div className='viewerQuestionTitle'>
          <span>{props?.question?.questionTitle}</span>
          <span className='requiredStatus'>
            {props?.question?.required ? "*Required" : ""}
          </span>
        </div>
        {props?.question?.questionMetadata?.choices?.map((option) => (
          <div className='choiceInputWrapper'>
            <input
              type='radio'
              className='ui-checkbox ui-radio'
              name={props?.questionTitle + " " + props?.question?.id}
              value={option}
              id={option + props?.question?.id}
              onChange={(e) => handleRes(e)}
              required={props?.question?.required}
            />{" "}
            <label
              htmlFor={option + props?.question?.id}
              style={{
                fontFamily: props?.font,
              }}
            >
              {option}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

const Range = (props) => {
  const [res, setRes] = useState(null);
  const handleRes = (e) => {
    setRes(e.target.value);
  };

  useEffect(() => {
    props?.updateResponse(res);
  }, [res]);
  return (
    <div>
      <div className='viewerQuestionTitle'>
        <span>{props?.question?.questionTitle}</span>
        <span className='requiredStatus'>
          {props?.question?.required ? "*Required" : ""}
        </span>
      </div>
      <div className='viewerFormQuestionWrapper'>
        <div class='range-input'>
          <input
            type='range'
            name={props?.question?.questionTitle}
            id={props?.question?.questionTitle}
            min={props?.question?.questionMetadata?.min}
            max={props?.question?.questionMetadata?.max}
            required={props?.question?.required}
            onChange={(e) => {
              document.getElementById(
                props?.question?.questionTitle + "range"
              ).innerHTML = e.target.value;
              handleRes(e);
            }}
          />
        </div>
        <div
          id={props?.question?.questionTitle + "range"}
          style={{
            position: "absolute",
            right: "10%",
            fontFamily: props?.font,
          }}
          className='rangeFormValue'
        ></div>
      </div>
    </div>
  );
};

const FileUpload = (props) => {
  return (
    <div>
      <div className='viewerFormQuestionWrapper'>
        <div className='viewerQuestionTitle'>
          <span>{props?.question?.questionTitle}</span>
          <span className='requiredStatus'>
            {props?.question?.required ? "*Required" : ""}
          </span>
        </div>
        <input
          type='file'
          name={props?.question?.questionTitle}
          id={props?.question?.questionTitle}
        />
      </div>
    </div>
  );
};

const ViewerForm = () => {
  const params = useParams();

  const [submit, setSubmit] = useState(false);
  const [state, setState] = useState(null);
  const [formId, setFormId] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [errorMessage, setErrorMessage] = useState(null);
  const [responses, setResponses] = useState([]);
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };

  const err = (message) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };
  useEffect(() => {
    setFormId(params?.id);
  }, []);

  useEffect(() => {
    getForm();
  }, [formId]);
  const [getForm, { loading }] = useLazyQuery(GET_USER_FORM, {
    fetchPolicy: "cache-and-network",
    variables: {
      getFormByIdQId: DecodeURL(formId),
    },
    onCompleted: (data) => {
      setState(data.getFormByIdQ);
      document.title = data.getFormByIdQ?.formTitle + " | Survey Hub";
    },
    onError: (error) => {
      err(error.message);
      setErrorMessage(error.message);
    },
  });

  const updateResponse = (response, question, idx) => {
    // console.log(responses, question?.id, idx);
    let temp;
    if (responses?.length > 0) {
      temp = [...responses];
    } else {
      temp = [];
    }
    temp[idx] = { questionId: question?.id, responseText: response };
    setResponses(temp);
  };
  const [submitResponse, submittedResponse] = useMutation(
    CREATE_FORM_RESPONSE,
    {
      variables: {
        formId: DecodeURL(formId),
        responseData: {
          userId: localStorage.getItem("shub-userId") || "Anon",
          response: responses,
        },
      },
      onCompleted: (data) => {
        setSubmit(true);
        setLoader(false);
      },
      onError: (err) => {
        setErrorMessage(err.message);
        setLoader(false);
      },
    }
  );

  const [submitAnonResponse, submittedAnonResponse] = useMutation(
    CREATE_ANON_RESPONSE,
    {
      variables: {
        formId: DecodeURL(formId),
        anonymousResponseData: {
          response: responses,
        },
      },
      onCompleted: (data) => {
        setSubmit(true);
        setLoader(false);
      },
      onError: (err) => {
        setErrorMessage(err.message);
        setLoader(false);
      },
    }
  );

  const handleSubmit = () => {
    document.querySelector(".submitBtn").disabled = true;
    let validated = false;
    setLoader(true);
    responses.forEach((response) => {
      if (
        response?.responseText === null ||
        response?.responseText === "" ||
        response?.responseText === undefined
      )
        validated = false;
      else validated = true;
    });

    // if (validated) submitResponse();
    // else alert("Missing required fields");
    if (validated) {
      if (localStorage.getItem("shub-userId")) {
        submitResponse();
      } else submitAnonResponse();
    } else err("Missing required fields");
    document.querySelector(".submitBtn").disabled = false;
  };
  return (
    <>
      {contextHolder}
      {loading ? (
        <section
          className='viewerFormSection position-relative '
          style={{
            background: "rgb(145 191 241)",
            fontFamily: "Lato,sans-serif",
          }}
        >
          {" "}
          <div className='viewerFormBox flex flex-row'>
            <Loader />{" "}
            <span className='fw-bold mx-5 text-lg'>Loading Form....</span>
          </div>
          <div
            className='credits flex flex-col items-center justify-center opacity-75'
            style={{ marginTop: "30px" }}
          >
            <span>Powered By</span>
            <h5 className='fw-bold'>Survey Hub</h5>
          </div>
        </section>
      ) : (
        <>
          {submit ? (
            <section className='flex flex-col items-center justify-center'>
              <ThankyouPage
                color={state?.formMetadata?.theme?.color}
                formTitle={state?.formTitle}
                description={state?.description}
              />
              <div className='credits flex flex-col items-center justify-center opacity-75 position-absolute bottom-0 '>
                <span>Powered By</span>
                <h5 className='fw-bold'>Survey Hub</h5>
              </div>
            </section>
          ) : (
            <section
              className='viewerFormSection position-relative '
              style={{
                background:
                  state?.formMetadata?.theme?.color || "rgb(145 191 241)",
                fontFamily:
                  state?.formMetadata?.theme?.font || "Lato,sans-serif",
              }}
            >
              {!loading && state?.formMetadata?.visibility !== "PUBLIC" && (
                <div className='viewerFormTop viewerFormBox'>
                  <span className='viewerQuestionTitle'>
                    {" "}
                    Oops! This form is not accepting submissions right now.
                  </span>
                </div>
              )}

              {state?.formMetadata?.visibility === "PUBLIC" && (
                <form
                  className='viewerForm min-vh-90 '
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  {state?.formMetadata?.theme?.image && (
                    <div
                      className='questionWrapper rounded'
                      style={{
                        backgroundImage: `url('${state?.formMetadata?.theme?.image}')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        minHeight: "250px",
                        overflow: "hidden",
                      }}
                    ></div>
                  )}
                  <div
                    className='viewerFormTop viewerFormBox'
                    style={{
                      padding: "12px",

                      boxShadow: darkenColor(
                        state?.formMetadata?.theme?.color
                      )?.includes("NaN")
                        ? "inset 0px -23px 0px -16px  rgb(35 35 35)"
                        : "inset 0px -23px 0px -16px " +
                          darkenColor(state?.formMetadata?.theme?.color),
                    }}
                  >
                    <div className='formTitle text-center'>
                      {state?.formTitle}
                    </div>
                    <div className='formDesc text-center'>
                      {state?.description}
                    </div>
                  </div>

                  <div
                    className='viewerFormQuestions'
                    style={{
                      fontFamily: state?.formMetadata?.theme?.font,
                    }}
                  >
                    {state?.questions?.map((question, idx) => (
                      <div
                        className='viewerFormBox'
                        style={{
                          boxShadow: darkenColor(
                            state?.formMetadata?.theme?.color
                          )?.includes("NaN")
                            ? "inset 0px -23px 0px -16px  rgb(35 35 35)"
                            : "inset 0px -23px 0px -16px " +
                              darkenColor(state?.formMetadata?.theme?.color),
                        }}
                        key={idx}
                      >
                        <div className='w-100'>
                          {question.questionType == questionTypes.PARAGRAPH && (
                            <Paragraph
                              question={question}
                              updateResponse={(e) =>
                                updateResponse(e, question, idx)
                              }
                            />
                          )}
                          {question.questionType ==
                            questionTypes.LINEAR_SCALE && (
                            <LinearScale
                              question={question}
                              updateResponse={(e) =>
                                updateResponse(e, question, idx)
                              }
                            />
                          )}
                          {question.questionType == questionTypes.RADIO && (
                            <Radio
                              question={question}
                              font={state?.formMetadata?.theme?.font}
                              updateResponse={(e) =>
                                updateResponse(e, question, idx)
                              }
                            />
                          )}
                          {question.questionType == questionTypes.CHECKBOX && (
                            <CheckBox
                              question={question}
                              font={state?.formMetadata?.theme?.font}
                              updateResponse={(e) =>
                                updateResponse(e, question, idx)
                              }
                            />
                          )}
                          {question.questionType == questionTypes.RANGE && (
                            <Range
                              question={question}
                              font={state?.formMetadata?.theme?.font}
                              updateResponse={(e) =>
                                updateResponse(e, question, idx)
                              }
                            />
                          )}
                          {question.questionType == questionTypes.UPLOAD && (
                            <FileUpload
                              question={question}
                              updateResponse={(e) =>
                                updateResponse(e, question, idx)
                              }
                            />
                          )}
                        </div>{" "}
                      </div>
                    ))}
                  </div>

                  <div className='viewerFormsubmitWrapper flex items-center content-between'>
                    <div className='responseCopyDiv'>
                      {/* <label class="responseCopyCheckbox">
                    Send a copy of my response
                    <input type="checkbox" />
                    <span class="checkmark"></span>
                  </label> */}
                    </div>
                    <button
                      className='submitBtn'
                      onClick={() =>
                        !(
                          submittedAnonResponse?.loading ||
                          submittedResponse?.loading
                        ) && handleSubmit()
                      }
                      disabled={
                        submittedAnonResponse?.loading ||
                        submittedResponse?.loading
                      }
                      style={{
                        background: darkenColor(
                          state?.formMetadata?.theme?.color
                        ),
                        border:
                          "2px solid " +
                          getContrastColor(state?.formMetadata?.theme?.color),
                      }}
                    >
                      {submittedAnonResponse?.loading ||
                      submittedResponse?.loading ? (
                        <>
                          {" "}
                          <Loader color='#fff' />
                          Submitting
                        </>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                  {errorMessage}
                </form>
              )}

              <div
                className='credits flex flex-col items-center justify-center opacity-75'
                style={{ marginTop: "30px" }}
              >
                <span>Powered By</span>
                <h5 className='fw-bold'>Survey Hub</h5>
              </div>
            </section>
          )}
        </>
      )}
    </>
  );
};

export default ViewerForm;
